module.exports = "/_next/static/images/89302e1b4005f0f9d1d8aa7dd38d8651-product-information-xs-1x.jpg";